<template>
  <div>
    <top-header></top-header>
    <site-header></site-header>
    <inner-banner title="Our Courses" current-page="Courses" />

    <!-- courses section -->
    <div class="w3l-grids-block-5 w3l-grids-block-6 py-5">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">Our <span>Courses</span></h3>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 mt-5" v-for="course in courses" :key="course.id">
            <div class="blog-card-single">
              <div class="grids5-info position-relative">
                <!-- 这里用接口返回的 course_url 作为图片地址 -->
                <ImageWithPlaceholder
                    :src="course.course_url"
                    :height="160"
                />
                <div class="meta-list">
                  <a
                      v-for="label in course.label_names"
                      :key="label"
                      href="javascript:void(0)"
                      class="me-1"
                      :style="{ backgroundColor: getRandomColorForLabel(label) }"
                  >
                    {{ label }}
                  </a>
                </div>

              </div>
              <div class="content-main-top">
                <div class="content-top mb-4 mt-3">
                  <ul class="list-unstyled d-flex align-items-center justify-content-between">
                    <li v-if="course.course_level">
                      <i class="fa fa-signal" aria-hidden="true"></i>
                      {{ course.course_level }}
                    </li>
                  </ul>
                </div>

                <!-- 课程名，点击跳转还是用 course_url 作为链接 -->
                <h4><a :href="course.course_url" target="_blank">{{ course.course_name }}</a></h4>
                <p v-html="$formatTextWithLineBreaks(course.course_content)"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //courses section -->

    <footer-component></footer-component>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import FooterComponent from '@/components/Footer.vue'
import InnerBanner from '@/components/InnerBanner.vue'
import { getCourses } from '@/api/course'
import ImageWithPlaceholder from "@/components/ImageWithPlaceholder.vue";

export default {
  name: 'CoursesPage',
  components: {
    ImageWithPlaceholder,
    TopHeader,
    SiteHeader,
    FooterComponent,
    InnerBanner
  },
  data() {
    return {
      courses: [],
      labelColorMap: {} // 缓存每个 label 的颜色，避免每次都变
    }
  },
  mounted() {
    this.fetchCourseList()
  },
  methods: {
    getRandomColorForLabel(label) {
      if (!this.labelColorMap[label]) {
        const colors = ['#1DC295', '#FF9800', '#03A9F4', '#E91E63', '#8BC34A', '#9C27B0', '#607D8B'];
        this.labelColorMap[label] = colors[Math.floor(Math.random() * colors.length)];
      }
      return this.labelColorMap[label];
    },
    async fetchCourseList() {
      try {
        const res = await getCourses()
        console.log('接口返回数据:', res)
        this.courses = Array.isArray(res)
            ? res.map(item => ({
              id: item.id,
              course_name: item.course_name,
              course_url: item.course_url || '', // 如果有封面字段就保留
              course_content: item.course_content, // 修复简介字段
              label_names: (item.course_labels || []).map(l => l.label_name) ,// 修复标签字段
              course_level: item.course_level || ''
            }))
            : []
        console.log(this.courses)
      } catch (e) {
        console.error('获取课程列表失败:', e)
        this.courses = []
      }
    }
  }
}
</script>

<style scoped>
.meta-list a {
  display: inline-block;
  background-color: #eee;
  padding: 2px 8px;
  margin-right: 4px;
  border-radius: 4px;
  font-size: 12px;
  text-decoration: none;
  color: #333;
}
</style>
